module.exports = __webpack_public_path__ + "static/media/goodgradesar.0a1cf043.jpg";